import React, { useEffect,useState,useRef }  from 'react';
import { DataGrid, GridToolbar, GridToolbarContainer } from '@mui/x-data-grid';
import Chip from '@mui/material/Chip';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { useServiceContext } from '../../components/Context/ServiceContext';
import { useNavigate } from 'react-router-dom';
const columns=[
    {
        field: 'link',
        headerName: 'Link',
        width: 50,
        renderCell: (params) => (
            <i className="bi bi-info-circle"></i>
        ),
    },
    { field: 'name', headerName: 'Coupan Name', width: 150 },
    { field: 'validity', headerName: 'Validity Up To', width: 150 },
    { field: 'branchesAvailable', headerName: 'Branches', width: 150 },
    { field: 'servicesApplicable', headerName: 'Services', width: 150 },
    { field: 'servicesOffered', headerName: 'Offered Services', width: 150 },
     {
        field: 'isActive',
        headerName: 'Status',
        width: 150,
        renderCell: (params) => (
            <div
                style={{
                    display: 'flex', // Use flexbox for centering
                    alignItems: 'center', // Vertically centers the chip
                    justifyContent: 'center', // Horizontally centers the chip
                    width: '100%', // Ensures full width
                    height: '100%', // Ensures full height
                }}
            >
                <Chip
                    label={params.value ? 'Active' : 'Inactive'} // Dynamic label
                    style={{
                        backgroundColor: params.value ? 'green' : '#cf0a0a', // Dynamic color
                        color: 'white', // Text color
                        fontWeight: 'bold', // Optional: Make the text bold
                    }}
                    size="small" // Makes the chip smaller
                />
            </div>
        ),
    },
  
   
];

const ViewCoupans=()=>{
     const navigate = useNavigate();
    const {getallcouponadmin}=useServiceContext();
    const [coupans,setCoupans]=useState([]);
    const didFetch=useRef(false);

    const transformData = (data) => { console.log("Original Data:", data);
         return data.map(item => { console.log("Transforming item:", item); 
             console.log("Item Services Offered:", item.servicesOffered); 
              return { id: item.id, 
                name: item.name,
                 validity: item.validity, 
                 branchesAvailable: (item.branchesAvailable || []).map(branch => `${branch.branchName} (${branch.streetName})`).join(', '), 
                 servicesApplicable: (item.servicesApplicable || []).map(service => `Name: ${service.serviceName}, Count: ${service.availCount}`).join('; '), 
                 servicesOffered: (item.serviceOffered || []).map(service => `ID: ${service.serviceId}, Name: ${service.serviceName}`).join(', '),
                isActive: item.isActive  }; }); 
    };
    const getData=async()=>{
        try{
            const data=await getallcouponadmin();
            //console.log(data);
            const transformedData = transformData(data);
            setCoupans(transformedData);
            
        }catch(error){
            console.log(error);
        }
        
    }
    useEffect(()=>{
        if(!didFetch.current){
            getData();
            didFetch.current=true;
        }
    });
    const handleRowClick = (params) => {
        // Navigate to the edit form with the branch ID
        navigate(`/Coupansedit/${params.id}/false`, { state: { coupans: params.row } });
    };
    

    const CustomToolbar = (props) => (
            <GridToolbarContainer>
                <EditToolbar {...props} />
                <GridToolbar />
            </GridToolbarContainer>
    );
    function EditToolbar(props) {
        const { setRows, setRowModesModel } = props;
        // return (
        //     <GridToolbarContainer>
        //         <Button color="primary" startIcon={<AddIcon />}>
                    
        //         </Button>
        //     </GridToolbarContainer>
        // );
    }

    const rows = coupans.map((item) => ({ ...item }));
    return(
            <main id="main" className="main">
            <div className="pagetitle">
            <h1>Coupans</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/branch">Home</a></li>
                       
                    </ol>
                </nav>
            </div>
            <section className="section">
                <div className="row">


                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-body">

                                <h5 className="card-title"></h5>
                                {/* Tabs */}
                                <Box sx={{ width: '100%' }}>
                                    <AppBar position="static" color="default">
                                        {/* AppBar content can go here */}
                                    </AppBar>
                                  
                                </Box>

                                <div style={{ height: '100%', width: '100%' }}>
                                    <DataGrid
                                        rows={rows}
                                        columns={columns}
                                        slots={{ toolbar: CustomToolbar }}
                                        onRowClick={handleRowClick}
                                        components={{ Toolbar: GridToolbar }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div></div>
            </section>
        </main>
    );

}
export default ViewCoupans;